<template>
  <div class="hzc-industry-dynamics no-li">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/oilBenzene')">石油苯</span> > <span
        @click="back('/oilBenzene/twoPage/price')" style="cursor: pointer">价格</span> > 正文
    </div>
    <div class="content">
      <div class="top">
        <p>{{ row.titleName }}</p>
        <span>发布时间：{{ row.showYearTime }}</span><span>来源：{{ row.updateBy || "网络" }}</span>
      </div>
      <div class="bom" v-html="row.newsContent"></div>
      <div class="echarts" v-if="flag === '17'">
        <div id="myChart" style="width: 900px;height:340px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  backPriceDetail,
  priceDetailDataHua
} from '@/api/oilBenzene'

export default {
  data() {
    return {
      row: {},
      page: 1,
      size: 15,
      total: 0,
      title: '',
      flag: '17',
      option: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: ["2019", '2020', '2021']
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [{
          name: '',
          type: "line",
          data: []
        }
        ],
        grid: {
          x: 100,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
    }
  },
  created() {
    if (this.$route.query.flag) {
      this.flag = this.$route.query.flag;
    }
    this.getIndustry();
  },
  methods: {
    // 行业动态
    getIndustry() {
      backPriceDetail(this.$route.query.id).then(res => {
        this.row = res.data;
        this.getMapData()
      })
    },
    /**
     * 获取地图信息
     */
    getMapData() {
      priceDetailDataHua({dictId: '670'}).then(res => {
        this.option.series[0]['name'] = '华东市场收盘价格'
        this.option.series[0]['data'] = res.data.dataList
        this.option['xAxis']['data'] = res.data['coordinate'];
        this.drawChart(this.option);
      })
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    },
    back(url) {
      this.$router.push({path: url, query: {flag: this.flag}});
    },
  }
}
</script>

<style scoped lang="less">
.hzc-industry-dynamics {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 20px;

  .content {
    width: 960px;
    min-height: 500px;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin: 16px auto 0;
    padding-bottom: 20px;

    .top {

      border-bottom: 1px solid #ccc;
      padding: 16px 0;
      text-align: center;

      p {
        color: #222;
        font-size: 24px;
      }

      span {
        display: inline-block;
        margin-right: 16px;
        color: #777777;
        font-size: 12px;
      }
    }

    .bom {
      padding: 16px 40px;

      ::v-deep {
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
